import { render } from "./AllowedparamsItem.vue?vue&type=template&id=074e6e29"
import script from "./AllowedparamsItem.vue?vue&type=script&lang=js"
export * from "./AllowedparamsItem.vue?vue&type=script&lang=js"

import "./AllowedparamsItem.vue?vue&type=style&index=0&id=074e6e29&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__